export const GetUsersActionTypes = {
  GET_USERS_LOADING: "GET_USERS_LOADING",
  GET_USERS_ERROR: "GET_USERS_ERROR",
  GET_USERS_SUCCESS: "GET_USERS_SUCCESS",
};
